import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsiteOverviewRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details-overview',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
	exact: true,
};
